import { createBrowserRouter } from 'react-router-dom';
import { RequireAgent } from '@/auth/RequireAgent';
import { SignInPage } from '@/auth/SignInPage';
import { AppLayout } from './AppLayout';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { TournamentPage } from '@/features/tournament/TournamentPage';
import { LinkBuilderPage } from '@/features/links/LinkBuilderPage';
import { WheelSpinsPage } from '@/features/wheel/WheelSpinsPage';
import { WhalesPage } from '@/features/whales/WhalesPage';
import { TrafficQualityPage } from '@/features/traffic-quality/TrafficQualityPage';

export const router = createBrowserRouter([
  { path: '/sign-in', element: <SignInPage /> },
  {
    element: <RequireAgent />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'tournaments/:tournamentId', element: <TournamentPage /> },
          { path: 'links', element: <LinkBuilderPage /> },
          { path: 'wheel', element: <WheelSpinsPage /> },
          { path: 'whales', element: <WhalesPage /> },
          { path: 'traffic-quality', element: <TrafficQualityPage /> },
        ],
      },
    ],
  },
]);
